export const ODOO_VS_SAKTI_API_CONFIG = {
    BASE_PATH: '/odoo/sakti',
    ENDPOINTS: {
        BKM_VS_SAKTI: '/bkm-vs-sakti',
    }
} as const;

export const getOdooVsSaktiEndpoint = (endpoint: keyof typeof ODOO_VS_SAKTI_API_CONFIG.ENDPOINTS): string => {
    return `${ODOO_VS_SAKTI_API_CONFIG.BASE_PATH}${ODOO_VS_SAKTI_API_CONFIG.ENDPOINTS[endpoint]}`;
};
